import { Component, Input, OnInit, Output, EventEmitter} from "@angular/core";
@Component({
  selector: "app-datetime-picker",
  template: require('./datetime-picker.component.html'),
  styles: [require('./datetime-picker.component.sass')]
})
export class DatetimePickerComponent implements OnInit {

  @Input() dateTime: string | number | Date;
  @Input() minDateTime: string | number | Date;  
  @Input() maxDateTime: string | number | Date; 
  @Input() isInputTimestamp: boolean = false;
  @Input() mask = "medium";
  @Input() meridian: boolean = false;
  @Input() placeholder:string="dd/MM/yyyy hh:mm"
  @Input() hourStep=1;
  @Input() minuteStep=1;

  @Output() change = new EventEmitter<any>();

  dateFormat="dd/mm/yy"

  @Output() dateSelected = new EventEmitter<any>();
  @Output() dateTimeChange = new EventEmitter<string | number | Date>();
  
  
  constructor() {}

  ngOnInit(): void {
   
  }

  ngOnChanges() {
    if (this.isInputTimestamp) {
      this.dateTime = new Date(this.dateTime);
      this.minDateTime = new Date(this.minDateTime);  
      this.maxDateTime = new Date(this.maxDateTime); 
    }
  }

  onSelect = (date: any) => {
    if (this.isInputTimestamp) {
      this.change.emit(new Date(date).getTime());
    } else {
      this.change.emit(date);
    }
  }

}

